/**
* @summary - Component that Provides PPM Generation functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import {
      Box
} from "@mui/material";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import { getFacilityId, getcompanyId } from '../../utility/tokenUtility';
import PageTitle from "../commoncomponents/PageTitle";
import PpmGenerationList from "./ppmGenerationList";
function PpmPlannerMain() {
      const facilityId = getFacilityId();
      const companyId = getcompanyId();
      const navigate = useNavigate();
      const handleHomeClick = () => {
            navigate('/dashboard'); // Adjust the path as needed
      };

      return (
            <>
                  <BreadcrumbBar>
                        <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>
                              <PageTitle title={"PPM Generation"} />
                        </Box>
                  </BreadcrumbBar>
                  <PpmGenerationList facilityId={facilityId} companyId={companyId} />
            </>
      );
}

export default PpmPlannerMain;
